/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterConversationUserQueryKind =
  (typeof FilterConversationUserQueryKind)[keyof typeof FilterConversationUserQueryKind];

export const FilterConversationUserQueryKind = {
  conversation_user_query: 'conversation_user_query',
} as const;
